import React from 'react';
import SelectCards from '../components/Select-cards';
import TemplateBodyField from '../components/template-body-field';
import CustomInputText from '../../../../components/common/CustomInputText';
import { Controller } from 'react-hook-form';
import styles from '../stylesheets/marketingProduct.module.css';
import redCrossIcon from '../../../../assets/svgIcons/redCross.svg';

const productTypeOptions = [
  { label: 'Catalog', value: 'CATALOG' },
  { label: 'Multi Product', value: 'MULTI' },
  { label: 'Single Product', value: 'SINGLE' },
];

const MarketingProductTemplate = ({
  control,
  watch,
  setValue,
  file,
  setFile,
  previewFile,
  validateMediaSize,
  getFormErrorMessage,

  textAreaRef,

  SPAM_SUGGESTIONS,
  showSpamSuggestions,
  setShowSpamSuggestions,
  checkForSpam,

  messsageVariables,
  menuRef,

  showEmoji,
  setShowEmoji,
  handleEmojiClick,

  tempVariables,
  handleEditVariable,
  handleDeleteVariable,
  watchContent,

  templateButtons,
  setTempBtn,
  handleQuickReplyChange,
  handleButtonEdit,
  removeButton,
  addQuickReplyBtn,
  handleAddCTA,
  getButtonTypeCounts,
}) => {
  const watchProductType = watch('productType');

  const getCTALabel = () => {
    switch (watchProductType) {
      case 'CATALOG':
        return 'View catalog';
      case 'MULTI':
        return 'View items';
      case 'SINGLE':
        return 'View';
      default:
        return 'View';
    }
  };

  return (
    <div className="flex flex-column gap-3 mt-3">
      {/* Product Type */}
      <div>
        <label className="form-label">Product Type</label>

        <Controller
          name="productType"
          control={control}
          defaultValue="CATALOG"
          render={({ field }) => (
            <div className={styles.segmentWrapper}>
              {productTypeOptions.map((item) => (
                <div
                  key={item.value}
                  className={`${styles.segmentItem} ${
                    field.value === item.value ? styles.segmentActive : ''
                  }`}
                  onClick={() => field.onChange(item.value)}
                >
                  {item.label}
                </div>
              ))}
            </div>
          )}
        />
      </div>

      {watchProductType !== 'SINGLE' && (
        <div>
          <label className="form-label">Thumbnail (optional)</label>

          <Controller
            name="productThumbnail"
            control={control}
            render={({ field }) => (
              <div>
                <label className={styles.uploadBox}>
                  <input
                    type="file"
                    accept="image/*"
                    className={styles.hiddenInput}
                    onChange={(e) => field.onChange(e.target.files[0])}
                  />

                  <div className={styles.browseContainer}>
                    <p className={styles.browse}>Browse Files</p>
                  </div>

                  <div className={styles.uploadContent}>
                    <i className="pi pi-upload" />
                    <span>Choose a file or Drag & drop</span>
                  </div>
                </label>

                {/* Preview */}
                {field.value && (
                  <div className={styles.previewContainer}>
                    <img
                      src={URL.createObjectURL(field.value)}
                      alt="preview"
                      className={styles.previewImage}
                    />

                    <img
                      src={redCrossIcon}
                      alt="Remove"
                      className={'mt-2'}
                      onClick={() => field.onChange(null)}
                    />
                  </div>
                )}
              </div>
            )}
          />
        </div>
      )}

      {/* Body */}
      <TemplateBodyField
        control={control}
        textAreaRef={textAreaRef}
        getFormErrorMessage={getFormErrorMessage}
        SPAM_SUGGESTIONS={SPAM_SUGGESTIONS}
        showSpamSuggestions={showSpamSuggestions}
        setShowSpamSuggestions={setShowSpamSuggestions}
        checkForSpam={checkForSpam}
        messsageVariables={messsageVariables}
        menuRef={menuRef}
        showEmoji={showEmoji}
        setShowEmoji={setShowEmoji}
        handleEmojiClick={handleEmojiClick}
        tempVariables={tempVariables}
        handleEditVariable={handleEditVariable}
        handleDeleteVariable={handleDeleteVariable}
        watchContent={watchContent}
      />

      {/* Footer only for Single */}
      {watchProductType === 'SINGLE' && (
        <div className="w-full">
          <CustomInputText
            name="footer"
            label="Footer"
            control={control}
            placeholer="Enter Footer Text"
            maxLength={60}
            required={false}
          />
        </div>
      )}

      <div>
        <label className={styles.CTALabel}>CTA</label>

        <div className={styles.ctaPreviewBox}>
          <div className={styles.CTAHeader}>
            <p className={styles.CTAHeadeLabel}>CTA preview</p>
          </div>

          <div className={styles.chatBubbleContainer}>
            <div className={styles.ctaButtonContainer}>
              <div className={styles.ctaButton}>{getCTALabel()}</div>
            </div>
          </div>
        </div>

        <div className={styles.infoBox}>ⓘ Products will be selected during campaign creation</div>
      </div>
    </div>
  );
};

export default MarketingProductTemplate;
